import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {

  publishNewSession: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presenting-sessions/snapshots?masterPresentationId={presentationId}`,
  },
  getPresentationMasterByPublishId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/master-presentations/by-snapshot-id/{presentationId}?alwaysGetRootPresentation={getRootPresentation}`,
  },
  getListSessionsByPresentationId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/snapshots?masterPresentationId={presentationId}&limit=100`,
  },
  getPresentationDetailBySession: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/snapshots/{presentationId}`,
  },

  createInstructor: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presenting-sessions/master-presentations/{presentationId}/instructors`,
  },

  getListInstructorByPresentationId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/master-presentations/{presentationId}/instructors`,
  },

  deleteInstructor: {
    method: 'DELETE',
    url: `${configs.baseUrl}/api/presenting-sessions/master-presentations/{presentationId}/instructors`,
  },

  getListSessionReportByPresentationId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/report`,
  },

  getRoleForPresentation: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presentation/{presentationId}/my-role`,
  },

  getMasterPresentationByRootId: {
    method: 'GET',
    url: `${configs.baseUrl}/api/presenting-sessions/master-presentations/by-root-id/{presentationId}`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getPresentationMasterByPresentationId = (presentationId, getRootPresentation = false) => {
  return resource.getPresentationMasterByPublishId({ getRootPresentation, presentationId })
}

const publishNewSession = (presentationId, socketId = undefined) => {
  return resource.publishNewSession({ presentationId, socketId }, null)
}

const getListSessionsByPresentationId = (presentationId, params = {}) => {
  return resource.getListSessionsByPresentationId({ presentationId, ...params })
}

const getPresentationDetailBySession = (presentationId) => {
  return resource.getPresentationDetailBySession({ presentationId })
}

const createInstructor = async (presentationId, payload, queryParams = {}) => {
  return resource.createInstructor({ presentationId, ...queryParams }, payload)
}

const deleteInstructor = async (presentationId, payload) => {
  return resource.deleteInstructor({ presentationId }, payload)
}

const getListInstructorByPresentationId = async (presentationId) => {
  return resource.getListInstructorByPresentationId({ presentationId })
}

const getListSessionReportByPresentationId = async (params) => {
  return resource.getListSessionReportByPresentationId(params)
}

const getRoleForPresentation = async (presentationId) => {
  return resource.getRoleForPresentation({ presentationId })
}

const getMasterPresentationByRootId = async (presentationId) => {
  return resource.getMasterPresentationByRootId({ presentationId })
}

export default {
  initResource,
  publishNewSession,
  getPresentationMasterByPresentationId,
  getListSessionsByPresentationId,
  getPresentationDetailBySession,
  createInstructor,
  getListInstructorByPresentationId,
  deleteInstructor,
  getListSessionReportByPresentationId,
  getRoleForPresentation,
  getMasterPresentationByRootId,
}
